
import Vue from "vue";
import {
    CheckIcon,
    AlertCircleIcon,
    AlertTriangleIcon,
    XIcon
} from 'vue-feather-icons'; 

export default Vue.extend({
    name:'RomaNotification',
    props: {
        originalNotification: {
            type: Object,
            required: false
        },
        customPosition: {
            type: Boolean,
            required: false,
        },
        showXIcon: {
            type: Boolean,
            required: false
        }
    },
    components: {
        CheckIcon,
        AlertCircleIcon,
        AlertTriangleIcon,
        XIcon
    },
    data(){
        return {}
    },
    computed: {
        notification: {
            get(){
                return this.originalNotification;
            },
            set(newValue){
                this.$emit('clean-notification');
            }
        }
    }
});
